export const DefaultApiUrl = "http://127.0.0.1:8080";
